import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { Attachments_ReportService } from './Attachments.report.index';
import { Carriers_ReportService } from './Carriers.report.index';
import { Instructions_ReportService } from './Instructions.report.index';
import { LoadContainers_ReportService } from './LoadContainers.report.index';
import { Lots_ReportService } from './Lots.report.index';
import { SerialNumbers_ReportService } from './SerialNumbers.report.index';
import { Owners_ReportService } from './Owners.report.index';
import { Discussions_ReportService } from './Discussions.report.index';
import { ExcelOrderImport_ReportService } from './ExcelOrderImport.report.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { DockAppointments_ReportService } from './DockAppointments.report.index';
import { Notifications_ReportService } from './Notifications.report.index';
import { Addresses_ReportService } from './Addresses.report.index';
import { Materials_ReportService } from './Materials.report.index';
import { Locations_ReportService } from './Locations.report.index';
import { AsnOrders_ReportService } from './AsnOrders.report.index';
import { PurchaseOrders_ReportService } from './PurchaseOrders.report.index';
import { Inventory_ReportService } from './Inventory.report.index';
import { SalesOrders_ReportService } from './SalesOrders.report.index';


@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.Attachments = this.injector.get(Attachments_ReportService);
    this.Carriers = this.injector.get(Carriers_ReportService);
    this.Instructions = this.injector.get(Instructions_ReportService);
    this.LoadContainers = this.injector.get(LoadContainers_ReportService);
    this.Lots = this.injector.get(Lots_ReportService);
    this.SerialNumbers = this.injector.get(SerialNumbers_ReportService);
    this.Owners = this.injector.get(Owners_ReportService);
    this.Discussions = this.injector.get(Discussions_ReportService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_ReportService);
    this.Invoices = this.injector.get(Invoices_ReportService);
    this.DockAppointments = this.injector.get(DockAppointments_ReportService);
    this.Notifications = this.injector.get(Notifications_ReportService);
    this.Addresses = this.injector.get(Addresses_ReportService);
    this.Materials = this.injector.get(Materials_ReportService);
    this.Locations = this.injector.get(Locations_ReportService);
    this.AsnOrders = this.injector.get(AsnOrders_ReportService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_ReportService);
    this.Inventory = this.injector.get(Inventory_ReportService);
    this.SalesOrders = this.injector.get(SalesOrders_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public Attachments: Attachments_ReportService;
    public Carriers: Carriers_ReportService;
    public Instructions: Instructions_ReportService;
    public LoadContainers: LoadContainers_ReportService;
    public Lots: Lots_ReportService;
    public SerialNumbers: SerialNumbers_ReportService;
    public Owners: Owners_ReportService;
    public Discussions: Discussions_ReportService;
    public ExcelOrderImport: ExcelOrderImport_ReportService;
    public Invoices: Invoices_ReportService;
    public DockAppointments: DockAppointments_ReportService;
    public Notifications: Notifications_ReportService;
    public Addresses: Addresses_ReportService;
    public Materials: Materials_ReportService;
    public Locations: Locations_ReportService;
    public AsnOrders: AsnOrders_ReportService;
    public PurchaseOrders: PurchaseOrders_ReportService;
    public Inventory: Inventory_ReportService;
    public SalesOrders: SalesOrders_ReportService;

  public FootPrintPortalManager: FootPrintPortalManager_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

